'use client';

import { usePathname, useRouter } from '@/i18n/routing';
import { Select, type SelectOptions } from '@/components/select';
import { useLocale } from 'next-intl';
import { useEffect, useState, useTransition } from 'react';

const selectLangs: SelectOptions[] = [
  { label: 'English', value: 'en' },
  { label: 'Bangla', value: 'bn' },
];

export const LanguageToggle = () => {
  const pathName = usePathname();
  const router = useRouter();
  const locale = useLocale();
  const [isPending, startTransition] = useTransition();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleLanguageChange = (value: 'en' | 'bn') => {
    startTransition(() => {
      router.replace(pathName, { locale: value, scroll: false });
    });
  };

  if (isPending || !mounted) {
    return (
      <div className={`relative `}>
        <div className="px-2 py-3 text-sm border rounded-md bg-gray-50 animate-pulse">
          <div className="flex items-center justify-between">
            <div className="h-4 bg-gray-300 rounded w-16"></div>
            <div className="h-3 w-3 bg-gray-300 rounded"></div>
          </div>
        </div>
        <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent rounded-md"></div>
      </div>
    );
  }

  return (
    <Select
      className="text-xs md:text-base"
      value={locale}
      options={selectLangs}
      onChange={(value: string) => handleLanguageChange(value as 'en' | 'bn')}
      disabled={isPending}
    />
  );
};
